import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d12ffec6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d12ffec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ffec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d12ffec6')) {
      api.createRecord('d12ffec6', component.options)
    } else {
      api.reload('d12ffec6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d12ffec6&scoped=true", function () {
      api.rerender('d12ffec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/index.vue"
export default component.exports